import { Card, CardContent } from "@/components/ui/card";
import AiArtistEnrichmentStep from "@/pages/artists/create/components/ai-enrichment-step";
import { ArtistCreateBasicInfoStep } from "@/pages/artists/create/components/basic-info-step";
import { ArtistMediaStep } from "@/pages/artists/create/components/media-step";
import SpotifyEnrichmentStep from "@/pages/artists/create/components/spotify-enrichment-step";
import {
  Stepper,
  useArtistCreateForm,
} from "@/pages/artists/create/hooks/use-artist-create-form";

export const ArtistCreate = () => (
  <Stepper.Provider variant="vertical">
    <ArtistCreateStepper />
  </Stepper.Provider>
);

const ArtistCreateStepper = () => {
  const { methods } = useArtistCreateForm();
  return (
    <div className="flex flex-col mb-20">
      <Stepper.Navigation>
        {methods.all.map((step) => (
          <Stepper.Step
            key={step.id}
            of={step.id}
            onClick={() => methods.goTo(step.id)}
          >
            <Stepper.Title>{step.title}</Stepper.Title>
            {step.description && (
              <Stepper.Description>{step.description}</Stepper.Description>
            )}
            {methods.current.id === step.id && (
              <Stepper.Panel>
                <Card className="p-4">
                  <CardContent className="p-0">
                    {methods.switch({
                      selection: () => <ArtistCreateBasicInfoStep />,
                      spotifyEnrichment: () => <SpotifyEnrichmentStep />,
                      aiEnrichment: () => <AiArtistEnrichmentStep />,
                      media: () => <ArtistMediaStep />,
                    })}
                  </CardContent>
                </Card>
              </Stepper.Panel>
            )}
          </Stepper.Step>
        ))}
      </Stepper.Navigation>
    </div>
  );
};
